import reduxStore from "../configureEnvStore";
import { BATTERY_CRITICAL_VALUE } from "../constants/Constants";
import { NOTIFICATION_TYPES } from "../constants/DataTrackNotificationConstants";
import { CALL_DATA, GLOBAL_MEETING_DATA, PublicVariables } from "../constants/PublicVariables";
import {
    setBatteryInfoObject,
    setBatteryState,
    setBatteryValue,
    setIsHighBatteryMsgSent,
    setIsLocalDeviceBatteryLow,
    setIsLowBatteryMsgSent,
    setLowBatteryParticipanteId,
    setShowLowBatteryMsg,
} from "../reducers/battery-network-info-reducer";
import { setCallParticipants, setIsMobileSessionInfoVisible } from "../reducers/common-reducer";
import { sendDataTrack } from "../shared/dataTrackFunction";
import { LogFirebase } from "./firestore";

class BatteryInfoService {
    setBatteryObject(obj) {
        this.batteryObject = obj;
    }

    callBatteryFunction() {
        let _this = this;
        return function () {
            const isConnected = reduxStore.getState().commonReducer.isRemoteParticipantJoined;
            if (isConnected) {
                _this.checkDeviceBattery();
            }
        };
    }

    updateBatteryInfoToRedux(batteryObj) {
        if (!batteryObj) return;

        const object = {
            charging: batteryObj.charging,
            chargingTime: batteryObj.chargingTime,
            dischargingTime: batteryObj.dischargingTime,
            level: batteryObj.level,
        };
        reduxStore.dispatch(setBatteryInfoObject(object));

        const deviceBattery = batteryObj.level * 100;
        const localBatteryValue = deviceBattery + "%";
        reduxStore.dispatch(setBatteryValue(localBatteryValue));

        if (batteryObj.charging === true) {
            reduxStore.dispatch(setBatteryState("Charging"));
        } else {
            reduxStore.dispatch(setBatteryState("Discharging"));
        }

        return deviceBattery;
    }

    checkDeviceBattery() {
        const { isRemoteParticipantJoined } = reduxStore.getState().commonReducer;
        const { isLowBatteryMsgSent, isHighBatteryMsgSent } = reduxStore.getState().batteryNetworkInfo;

        if (isRemoteParticipantJoined && PublicVariables.isMobile) {
            // Setting Local Device Battery Val
            const deviceBattery = this.updateBatteryInfoToRedux(this.batteryObject);
            console.log(deviceBattery);

            if (deviceBattery < BATTERY_CRITICAL_VALUE) {
                this.showDeviceBatteryLowMessage("local");
                if (!isLowBatteryMsgSent || isHighBatteryMsgSent) {
                    LogFirebase("Battery", "batteryLevel", "Battery Low");
                    reduxStore.dispatch(setIsLowBatteryMsgSent(true));
                    reduxStore.dispatch(setIsHighBatteryMsgSent(false));
                }
            } else {
                const msg = {
                    identity: CALL_DATA.localIdentity,
                    device_type: GLOBAL_MEETING_DATA.device_type,
                    batteryVal: deviceBattery,
                };
                this.hideDeviceBatteryLowMessage("local", msg);
                if (isLowBatteryMsgSent) {
                    LogFirebase("Battery", "batteryLevel", "Battery High");
                    reduxStore.dispatch(setIsLowBatteryMsgSent(false));
                    reduxStore.dispatch(setIsHighBatteryMsgSent(true));
                }
            }
            this.sendBatteryLowMsgToAgent(deviceBattery);
        } else {
            //do nothing
        }
    }

    hideDeviceBatteryLowMessage(fromWhere, msg) {
        if (fromWhere === "local" && PublicVariables.isMobile) {
            this.updateBatteryInfoToRedux(this.batteryObject);
            reduxStore.dispatch(setIsLocalDeviceBatteryLow(false));
        }
        const callParticipants = reduxStore.getState().commonReducer.callParticipants;
        if (GLOBAL_MEETING_DATA.isAgent) {
            const updatedParticipants = callParticipants.map((user) => {
                if (user.identity === msg.identity) {
                    return { ...user, device_type: msg.device_type, isBatteryLow: "0", batteryVal: Math.round(msg.batteryVal) + "%" };
                }
                return user;
            });
            reduxStore.dispatch(setCallParticipants(updatedParticipants));
        }
        reduxStore.dispatch(setShowLowBatteryMsg(false));
        this.isNetworkAndBatteryMessage();
    }

    showDeviceBatteryLowMessage(fromWhere, msg) {
        const lowBatteryParticipanteId = fromWhere === "remote" ? msg.identity : CALL_DATA.localIdentity;
        reduxStore.dispatch(setLowBatteryParticipanteId(lowBatteryParticipanteId));

        if (GLOBAL_MEETING_DATA.isAgent) {
            const callParticipants = reduxStore.getState().commonReducer.callParticipants;

            const updatedParticipants = callParticipants.map((user) => {
                if (fromWhere === "remote" && user.identity === msg.identity) {
                    return { ...user, device_type: msg.device_type, isBatteryLow: "1", batteryVal: Math.round(msg.batteryVal) + "%" };
                }
                return user;
            });
            reduxStore.dispatch(setCallParticipants(updatedParticipants));
        }

        if (fromWhere === "local") {
            this.updateBatteryInfoToRedux(this.batteryObject);
            reduxStore.dispatch(setIsLocalDeviceBatteryLow(true));
        }

        reduxStore.dispatch(setShowLowBatteryMsg(true));
        this.isNetworkAndBatteryMessage();
    }

    isNetworkAndBatteryMessage() {
        if (PublicVariables.isMobile) {
            reduxStore.dispatch(setIsMobileSessionInfoVisible(true));
        }
    }

    sendBatteryLowMsgToAgent(deviceBattery) {
        if (GLOBAL_MEETING_DATA.isGuest) {
            const msg = {
                notification_type: NOTIFICATION_TYPES.BATTERY_LOW_MESSAGE,
                identity: CALL_DATA.localIdentity,
                device_type: GLOBAL_MEETING_DATA.device_type,
                batteryVal: deviceBattery,
            };
            sendDataTrack(msg);
        }
    }
}

export default new BatteryInfoService();
